<script lang="ts">
	import type { Snippet } from 'svelte';

	interface Props {
		/** Input label */
		label: string | Snippet;
		/** Whether the row checkbox is checked */
		checked: boolean;
		/** Called when the checkbox changes */
		onchange: (e: Event & { currentTarget: HTMLInputElement }) => void;
		/** Patch/icon slot (LegendPatch or LegendIcon); omit for a plain checkbox row */
		children?: Snippet;
		disabled?: boolean;
		/** Why the row is disabled; announced with the checkbox (show one visible hint per section). */
		disabledTooltip?: string;
	}

	const {
		label,
		checked,
		onchange,
		children,
		disabled = false,
		disabledTooltip = ''
	}: Props = $props();

	const reasonId = $props.id();
</script>

<label class="checkboxContainer">
	<input
		type="checkbox"
		{checked}
		{disabled}
		{onchange}
		aria-describedby={disabled && disabledTooltip ? reasonId : undefined} />
	{#if children}
		{@render children()}
	{/if}
	<span class="text">
		<span
			>{#if typeof label === 'function'}{@render label()}{:else}{label}{/if}</span>
		{#if disabled && disabledTooltip}
			<span class="screenReaderOnly" id={reasonId}>{disabledTooltip}</span>
		{/if}
	</span>
</label>

<style>
	.checkboxContainer {
		display: flex;
		align-items: center;
		gap: var(--space-3);
		min-height: var(--target-min);
		font-size: var(--font-size-sm);
	}

	.text {
		display: flex;
		flex-direction: column;
	}
</style>
